module.exports = __webpack_public_path__ + "img/logo_bonsai.fd2b596f.svg";